export default __webpack_public_path__ + "static/media/IMG_2224.2455cd84.JPG";